export default __webpack_public_path__ + "static/media/include_8_female@3x.6d365fe8.jpg";